export function createApiAction(
  apiCaller,
  {
    errorType,
    requestType,
    responseType,
    errorConverter = error => error.data,
    responseConverter = data => data,
    onError = () => null,
    onRequest = () => null,
    onResponse = () => null,
  }
) {
  function action(args) {
    function errorAction(error) {
      return dispatch => {
        const data = errorConverter(error);
        if (data === undefined) {
          throw error;
        }
        dispatch({ type: errorType, data });
        onError(dispatch, error, args);
      };
    }

    function requestAction() {
      return dispatch => {
        dispatch({ type: requestType });
        onRequest(dispatch, args);
      };
    }

    function responseAction(data) {
      return dispatch => {
        dispatch({ type: responseType, data: responseConverter(data) });
        onResponse(dispatch, data, args);
      };
    }

    return dispatch => {
      dispatch(requestAction());
      apiCaller(args)
        .then(resp => dispatch(responseAction(resp)))
        .catch(error => dispatch(errorAction(error)));
    };
  }

  return action;
}

export default {
  createApiAction,
};
